import React from "react"

const About = () => <>
  <h1>About Page</h1>
  <p>About content placeholder</p>
</>

export default About